import { getDownloadURL, ref, uploadBytes, deleteObject } from "firebase/storage";
import { storage } from "./Firebase";


/**
 * 파일 Storage에 업로드
 * @async
 * @function uploadFiles
 * @param {string} prefix - 업무 Prefix(recruit, media 등..)
 * @param {string} docId - docId (Firestore Document ID)
 * @param {string} type - 파일 유형 (image, attachment 등..)
 * @param {File[]} files - 실제 업로드 파일 배열
 * @returns Promise<string[]>
 */
const uploadFiles = async (prefix: string, docId: string, type: string, files: File[]): Promise<string[]> => {
    const uploadedFileUrls: string[] = [];

    for (const file of files) {
        const uploadFilenameWithPath = `${prefix}/${docId}/${type}/${file.name}`;
        const storageRef = ref(storage, uploadFilenameWithPath);
        const uploadResult = await uploadBytes(storageRef, file);
        const downloadUrl = await getDownloadURL(uploadResult.ref);

        uploadedFileUrls.push(downloadUrl);
    }

    return uploadedFileUrls;
};

/**
 * 주어진 Storage 경로의 파일 삭제
 * @async
 * @function deleteFileByPath
 * @param {string} path - Storage 내 파일 경로 (예: 'recruit/abc123/image/filename.png')
 * @returns Promise<void>
 */
const deleteFileByPath = async (path: string): Promise<void> => {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
};

/**
 * 주어진 prefix와 docId에 해당하는 모든 파일 삭제
 * @async
 * @function deleteAllFilesInFolder
 * @param {string} prefix - 업무 Prefix (예: 'recruit')
 * @param {string} docId - 문서 ID
 * @returns Promise<void>
 */
const deleteAllFilesInFolder = async (prefix: string, docId: string): Promise<void> => {
    const folderPath = `${prefix}/${docId}`;
    const folderRef = ref(storage, folderPath);

    // Firebase Web SDK에서는 폴더 내 모든 파일을 직접 나열할 수 없으므로 REST API 또는 Admin SDK 필요
    // 대안으로는 listAll() 사용 (단, 해당 경로 하위의 파일 수가 많지 않아야 함)
    const { listAll } = await import("firebase/storage");
    const listResult = await listAll(folderRef);

    const deletionPromises = listResult.items.map((itemRef) => deleteObject(itemRef));
    await Promise.all(deletionPromises);
};

export { uploadFiles, deleteFileByPath, deleteAllFilesInFolder };